import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { FaChevronRight, FaHome } from 'react-icons/fa';
import './BreadCrumb.scss';

const BreadCrumb = () => {
    const { selectedMenu: {
        // sub_menus
        name, link } = {}, selectedSubMenu } = useSelector(state => state.auth);
    let breadcrumbs = [{ name, link }];

    if (!name) {
        return null;
    }
    breadcrumbs.push({ name: selectedSubMenu?.name, link: selectedSubMenu?.url });

    const containerVariants = {
        hidden: { opacity: 0, y: -10 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.3,
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, x: -10 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.2 }
        }
    };

    return (
        <motion.nav
            aria-label="breadcrumb"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.ol className="breadcrumb enhanced-breadcrumb">
                <motion.li
                    className="breadcrumb-item home-item"
                    variants={itemVariants}
                >
                    <Link to="/" aria-label="Home">
                        <FaHome className="home-icon" />
                    </Link>
                    <FaChevronRight className="separator-icon" />
                </motion.li>
                {breadcrumbs.map((breadcrumb, index) => (
                    <motion.li
                        key={index}
                        variants={itemVariants}
                        className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}
                        aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}
                    >
                        {index < breadcrumbs.length - 1 ? (
                            <>
                                <Link
                                    to={breadcrumb.link}
                                    className="breadcrumb-link"
                                >
                                    {breadcrumb.name}
                                </Link>
                                <FaChevronRight className="separator-icon" />
                            </>
                        ) : (
                            <span className="current-page">{breadcrumb.name}</span>
                        )}
                    </motion.li>
                ))}
            </motion.ol>
        </motion.nav>
    );
};

export default BreadCrumb;
